// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#qi-core-coverage pre{padding-bottom:7px}", "",{"version":3,"sources":["webpack://./src/components/editMeasure/testCases/components/editTestCase/groupCoverage/QiCoreGroupCoverage.scss"],"names":[],"mappings":"AACE,sBACE,kBAAA","sourcesContent":["#qi-core-coverage {\n  pre {\n    padding-bottom: 7px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
